import { User } from '../types';

// Usuarios mock — solo datos públicos para resolución de nombres en UI.
// NO incluir credenciales aquí; el login real usa el backend JWT.
export const mockUsers: User[] = [
  {
    id: '1',
    username: 'admin',
    role: 'ADMIN',
    nombre: 'Administrador Sistema',
    avatar: undefined,
  },
  {
    id: '2',
    username: 'banca',
    role: 'BANCA',
    nombre: 'Banca La Fortuna',
    bancaId: 'B001',
  },
  {
    id: '3',
    username: 'local',
    role: 'LOCAL',
    nombre: 'Local Centro',
    bancaId: 'B001',
    localId: 'L001',
  },
  {
    id: '4',
    username: 'vendedor1',
    role: 'VENDEDOR_CON_CAJA',
    nombre: 'María Rodríguez',
    bancaId: 'B001',
    localId: 'L001',
  },
  {
    id: '5',
    username: 'vendedor2',
    role: 'VENDEDOR_SIN_CAJA',
    nombre: 'Carlos Jiménez',
    bancaId: 'B001',
    localId: 'L001',
  },
];
